/* PH Import — PDP image-gallery tabs (native, from A/B winner v7)
   Markup is server-rendered by snippets/product-gallery-tabs.liquid.
   This only wires interactivity to the theme's existing Flickity slider. */
(function () {
  'use strict';

  var TAB_ATTR = 'data-phab-tab';
  var IDX_ATTR = 'data-phab-idx';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    var slider = document.querySelector('#Product-Slider');
    var nav = document.querySelector('.phab-gallery-tabs');
    var wrap = document.querySelector('.phab-thumbs-wrap');
    if (!slider || !nav || !wrap) return;

    var row = wrap.querySelector('.phab-thumbs');
    var prev = wrap.querySelector('.phab-thumbs-nav--prev');
    var next = wrap.querySelector('.phab-thumbs-nav--next');
    if (!row) return;

    function getFlkty() {
      if (slider.flkty) return slider.flkty;
      if (window.Flickity && typeof Flickity.data === 'function') return Flickity.data(slider);
      return null;
    }

    function selectIndex(idx) {
      var f = getFlkty();
      if (f && typeof f.select === 'function') f.select(idx, false, true);
    }

    function thumbByIndex(idx) {
      return row.querySelector('.phab-thumb[' + IDX_ATTR + '="' + idx + '"]');
    }

    function setActiveTab(tabKey) {
      Array.prototype.forEach.call(nav.querySelectorAll('.phab-tab'), function (t) {
        var on = t.getAttribute(TAB_ATTR) === tabKey;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) keepTabInStrip(t);
      });
    }

    function setActiveThumb(idx) {
      var idxStr = String(idx);
      Array.prototype.forEach.call(row.querySelectorAll('.phab-thumb'), function (t) {
        t.classList.toggle('is-active', t.getAttribute(IDX_ATTR) === idxStr);
      });
    }

    function keepTabInStrip(el) {
      try {
        var cr = nav.getBoundingClientRect();
        var er = el.getBoundingClientRect();
        var pad = 12;
        if (er.left < cr.left) nav.scrollLeft -= (cr.left - er.left) + pad;
        else if (er.right > cr.right) nav.scrollLeft += (er.right - cr.right) + pad;
      } catch (e) {}
    }

    // Scroll a thumb to the left edge of the row (used on tab switch).
    function scrollThumbToStart(tile, smooth) {
      try {
        var delta = tile.getBoundingClientRect().left - row.getBoundingClientRect().left - 4;
        var target = row.scrollLeft + delta;
        if (smooth && typeof row.scrollTo === 'function') {
          row.scrollTo({ left: target, behavior: 'smooth' });
        } else {
          row.scrollLeft = target;
        }
      } catch (e) {}
    }

    // Nudge a thumb just into view (used on slider change / swipe).
    function scrollThumbIntoView(tile) {
      try {
        var cr = row.getBoundingClientRect();
        var er = tile.getBoundingClientRect();
        var pad = 12;
        if (er.left < cr.left) row.scrollLeft -= (cr.left - er.left) + pad;
        else if (er.right > cr.right) row.scrollLeft += (er.right - cr.right) + pad;
      } catch (e) {}
    }

    // ---- Nav arrows: hide when not scrollable, disable at the extremes ----
    function updateArrows() {
      if (!prev || !next) return;
      var max = row.scrollWidth - row.clientWidth;
      if (max <= 1) {
        prev.setAttribute('hidden', '');
        next.setAttribute('hidden', '');
        return;
      }
      prev.removeAttribute('hidden');
      next.removeAttribute('hidden');
      var sl = row.scrollLeft;
      prev.classList.toggle('is-disabled', sl <= 0);
      next.classList.toggle('is-disabled', sl >= max - 1);
    }

    function scrollRow(dir) {
      var step = Math.max(row.clientWidth * 0.8, 160);
      var target = row.scrollLeft + dir * step;
      if (typeof row.scrollTo === 'function') row.scrollTo({ left: target, behavior: 'smooth' });
      else row.scrollLeft = target;
    }

    if (prev) prev.addEventListener('click', function () {
      if (!prev.classList.contains('is-disabled')) scrollRow(-1);
    });
    if (next) next.addEventListener('click', function () {
      if (!next.classList.contains('is-disabled')) scrollRow(1);
    });

    // Recompute arrow state on scroll (rAF-throttled), resize, and image load.
    var ticking = false;
    row.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { updateArrows(); ticking = false; });
    });
    window.addEventListener('resize', updateArrows);
    Array.prototype.forEach.call(row.querySelectorAll('.phab-thumb img'), function (img) {
      if (!img.complete) img.addEventListener('load', updateArrows, { once: true });
    });

    // ---- Tab click: scroll to + select that tab's first thumb ----
    var suppressSyncScroll = false;
    nav.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.phab-tab') : null;
      if (!btn || !nav.contains(btn)) return;
      e.preventDefault();
      var key = btn.getAttribute(TAB_ATTR);
      if (key == null) return;
      setActiveTab(key);
      var first = row.querySelector('.phab-thumb[' + TAB_ATTR + '="' + key + '"]');
      if (!first) return;
      var idx = parseInt(first.getAttribute(IDX_ATTR), 10);
      if (isNaN(idx)) return;
      setActiveThumb(idx);
      // The change handler would otherwise nudge the same thumb mid-animation.
      suppressSyncScroll = true;
      scrollThumbToStart(first, true);
      selectIndex(idx);
      setTimeout(function () { suppressSyncScroll = false; }, 450);
    });

    // ---- Thumb click: select that media ----
    row.addEventListener('click', function (e) {
      var tile = e.target.closest ? e.target.closest('.phab-thumb') : null;
      if (!tile || !row.contains(tile)) return;
      e.preventDefault();
      var idx = parseInt(tile.getAttribute(IDX_ATTR), 10);
      if (isNaN(idx)) return;
      setActiveThumb(idx);
      selectIndex(idx);
    });

    // ---- Sync from the slider (swipe, dots, prev/next) ----
    function syncTo(idx) {
      if (idx < 0) return;
      var tile = thumbByIndex(idx);
      if (!tile) return;
      setActiveTab(tile.getAttribute(TAB_ATTR));
      setActiveThumb(idx);
      if (!suppressSyncScroll) scrollThumbIntoView(tile);
    }

    function bindFlkty(attempt) {
      var f = getFlkty();
      if (!f) {
        if (attempt < 40) { setTimeout(function () { bindFlkty(attempt + 1); }, 75); }
        return;
      }
      f.on('change', function (i) { syncTo(i); });
      syncTo(typeof f.selectedIndex === 'number' ? f.selectedIndex : 0);
      updateArrows();
    }
    bindFlkty(0);
    updateArrows();
  });
})();
